import { FC } from 'react';

import { StyledCard } from './Card.styles';
import { CardProps, CardVariants } from './Card.types';

const Card: FC<CardProps> = ({ children, css, variant = CardVariants.PRIMARY }) => {
  return (
    <StyledCard css={{ ...css }} variant={variant}>
      {children}
    </StyledCard>
  );
};

export default Card;
